export enum ModalType {
  LOGIN = 'LOGIN',
  REGISTER = 'REGISTER',
  RESET_PASSWORD = 'RESET_PASSWORD',
  OPEN_TICKET = 'OPEN_TICKET',
  CLOSE_TICKET = 'CLOSE_TICKET',
  OPEN_CHAT = 'OPEN_CHAT',
  EXPORT_CHAT = 'EXPORT_CHAT',
  COOKIE_PREFERENCES = 'COOKIE_PREFERENCES',
  CUSTOM = 'CUSTOM',
}

export interface ModalPropsMap {
  [ModalType.LOGIN]: {
    onSuccess?: () => void
    onResetPassword?: () => void
    onRegister?: () => void
  }
  [ModalType.REGISTER]: {
    onSuccess?: () => void
  }
  [ModalType.RESET_PASSWORD]: {
    email?: string
    onSuccess?: () => void
    backToLogin?: JSX.Element
  }
  [ModalType.OPEN_TICKET]: Record<string, never>
  [ModalType.CLOSE_TICKET]: {
    ticketId: string
    onSuccess?: () => void
  }
  [ModalType.OPEN_CHAT]: Record<string, never>
  [ModalType.EXPORT_CHAT]: {
    onSuccess?: () => void
  }
  [ModalType.COOKIE_PREFERENCES]: Record<string, never>
  [ModalType.CUSTOM]: {
    component: React.ReactNode
  }
}

export interface ModalOptions {
  dismissable?: boolean
  showBackButton?: boolean
  onClose?: () => void
}

export interface ModalStackEntry<T extends ModalType = ModalType> {
  id: string
  type: T
  props: ModalPropsMap[T]
  options: ModalOptions
}
